import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ReviewState } from './review.state';

const selectReviewState = createFeatureSelector<ReviewState>('review');

export const selectReviewItems = createSelector(selectReviewState, state => state.reviewItems);
export const selectReviewItemsLoading = createSelector(selectReviewState, state => state.loadingReviewItems);
export const selectUserProcessId = createSelector(selectReviewState, state => state.userProcessId);
export const selectDownloadInProgress = createSelector(selectReviewState, state => state.downloadInProgress);
